
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.16 6.882h-2.205A6.971 6.971 0 009.992 0a6.965 6.965 0 00-6.96 6.882H.83c-.78.06-.861.73-.82.971L1.95 19.306c.07.4.417.694.82.694h14.442a.83.83 0 00.82-.694L19.98 7.853c.04-.24-.057-.914-.82-.971zM9.992 1.665a5.3 5.3 0 015.294 5.213H4.698a5.3 5.3 0 015.294-5.213z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.519 12.192h6.942a.83.83 0 00.833-.833.83.83 0 00-.833-.832H6.52a.834.834 0 000 1.665zM6.519 16.355h6.942a.83.83 0 00.833-.833.83.83 0 00-.833-.832H6.52a.833.833 0 000 1.665z","fill":"#fff"}})])
          )
        }
      }
    